import { useEffect } from 'react'

export const useCartToast = () => {
  useEffect(() => {
    const handleItemAddedToCart = () => {
      // Toast removido conforme solicitado
    }

    window.addEventListener('itemAddedToCart', handleItemAddedToCart)

    return () => {
      window.removeEventListener('itemAddedToCart', handleItemAddedToCart)
    }
  }, [])
}
